import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";
import MRRESHCHANDRADAS from "../images/Naresh Chandra Das _Chairman.jpeg";
import MrAmitavaGuha from "../images/director.jpeg";
import Dr_SankarPrasadDutta from "../images/Dr. Sankar Prasad Dutta_principal.png";
import DrRameshKumarAgarwal from "../images/Dr. Ramesh Kumar Agarwal.jpg";
import MsIndraniBhattacharyya from "../images/Ms. Indrani Bhattacharyya.jpg";
import MrsSangaChakraborty from "../images/Mrs. Sanga Chakraborty.jpg";
import OurHod from './OurHod';

import AdministrativeStaff from './AdministrativeStaff';


function Ourteam() {
    return (
        <div>
            <Navbar />
            <br />
            <br />

            <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>

            <div className='cbscschoolnadia'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Our Team <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <ScrollToTop smooth top="100" color="darkgoldenrod" />
            <br />

            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 className="card-title mb-0"><b>Our Team</b></h1>
                            <div className="col-md-2">
                                <hr style={{ color: "#1D4D93" }} />
                            </div>

                            <h1><b style={{ color: "#1FA63F" }} >Leadership Team</b></h1>
                        </div>
                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3 mt-3">
                            <a href='NareshChandraDas_chairman'>
                                <div className='cardmotation'>
                                    <div className="card">
                                        <img src={MRRESHCHANDRADAS} className="card-img-top" alt="MR. NARESH CHANDRA DAS" />
                                        <div className="card-body">

                                            <h5 style={{ color: "#113263" }} className="card-title mb-2">Mr. Naresh Chandra Das</h5>
                                            <p className="card-text mb-1">Chairman Organizing Trust, NCDTE</p>
                                            <a href="NareshChandraDas_chairman" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                            </svg></a>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div className="col-md-3 mt-3">
                            <a href='Mr.AmitavaGuha_director'>
                                <div className='cardmotation'>
                                    <div className="card">
                                        <img src={MrAmitavaGuha} className="card-img-top" alt="Mr. Amitava Guha" />
                                        <div className="card-body">
                                            <h5 style={{ color: "#113263" }} className="card-title mb-2">Mr. Amitava Guha</h5>
                                            <p className="card-text mb-1">Director</p>
                                            <a href="Mr.AmitavaGuha_director" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                            </svg></a>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div className="col-md-3 mt-3">
                            <div className='cardmotation'>
                                <div className="card">
                                    <img src={Dr_SankarPrasadDutta} className="card-img-top" alt="Dr. Sankar Prasad Dutta" />
                                    <div className="card-body">
                                        <h5 style={{ color: "#113263" }} className="card-title mb-2">Dr. Sankar Prasad Dutta</h5>
                                        <p className="card-text mb-1">Principal</p>
                                        <a href="Dr.SankarPrasadDutta_Principal" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                        </svg></a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 mt-3">
                            <div className='cardmotation'>
                                <div className="card">
                                    <img src={DrRameshKumarAgarwal} className="card-img-top" alt="Dr. Ramesh Kumar Agarwal" />
                                    <div className="card-body">
                                        <h6 style={{ color: "#113263" }} className="card-title mb-2">Dr. Ramesh Kumar Agarwal</h6>
                                        <p className="card-text mb-1">Vice Principal</p>
                                        <a href="Dr.RameshKumarAgarwal" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                        </svg></a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 mt-3">
                            <div className='cardmotation'>
                                <div className="card">
                                    <img src={MsIndraniBhattacharyya} className="card-img-top" alt="Ms. Indrani Bhattacharyya" />
                                    <div className="card-body">
                                        <h5 style={{ color: "#113263" }} className="card-title mb-2">Ms. Indrani Bhattacharyya</h5>
                                        <p className="card-text mb-1">Headmistress (Senior)</p>
                                        <a href="MsIndraniBhattacharyya" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                        </svg></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mt-3">
                            <div className='cardmotation'>
                                <a href='SangaChakraborty'>
                                    <div className="card">
                                        <img src={MrsSangaChakraborty} className="card-img-top" alt="Mrs. Sanga Chakraborty" />
                                        <div className="card-body">
                                            <h5 style={{ color: "#113263" }} className="card-title mb-2">Mrs. Sanga Chakraborty</h5>
                                            <p className="card-text mb-1">Headmistress (Primary)</p>
                                            <a href="SangaChakraborty" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                            </svg></a>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />

            <div className='hodbackground'>
                <br />

                <br />
                <div className="album py-0">
                    <div className="container">
                        <button className='hod mb-3'>Our HOD</button>
                        <p className='justify'>It is true that a well trained teacher can bring out successful students. The teachers of KPS are sent to attend different workshops conducted by CBSE at regular intervals.</p>
                    </div>

                </div>

                <OurHod />
                <br />
                <br />
                <hr/>
                
            
                 </div>



                <br/>

                <AdministrativeStaff/>
                <br/>
           

        </div>
    )
}

export default Ourteam